var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-img',_vm._b({staticClass:"bg-black",style:(_vm.styles),on:{"load":_vm.onLoad}},'nuxt-img',_vm.attributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }